import angular from 'angular';

import DataSettingsComponent from './data.cmpt';

export default angular
    .module('application.scene.authorized.scene.settings.scene.data', [])
    .component(DataSettingsComponent.selector, DataSettingsComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized.calendar.settings.data', {
        url: '/data?action',
        component: DataSettingsComponent.selector
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/scene/data/index.js